import { pushToPixel } from "../services/sendEvent";

export const fireEventOnPageLanding = (data) => {
    // Call pushToPixel function with event-label "Lead"
    pushToPixel({
        eventLabel: data,
    }, true);
}